import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { defiTheme } from './theme/defiTheme';

import NewDashboard from './pages/Dashboard';
import ContractAnalysis from './pages/ContractAnalysis';
import VulnerabilityReport from './pages/VulnerabilityReport';
import Layout from './components/Layout';

// API endpoint configured via environment variable
export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider theme={defiTheme}>
        <CssBaseline />
        <Layout>
          <Routes>
            <Route path="/" element={<NewDashboard />} />
            <Route path="/analyze" element={<ContractAnalysis />} />
            <Route path="/report/:contractId" element={<VulnerabilityReport />} />
          </Routes>
        </Layout>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;